export const MINIMUM_RESULT_HEIGHT_PX = 60;
export const RESULT_GAP_PX = 24;

/**
 * Returns the maximum number of results to show in a container given a
 * container height. Recommended to use window.innerHeight as the container height
 * as the header acts a built in safety factor.
 */
export const getMaxResultsToShow = (containerHeight: number) => {
	// This formula comes from solving for x, where x is the number of results to show
	// containerHeight = x * MINIMUM_RESULT_HEIGHT_PX + (x - 1) * RESULT_GAP_PX
	// containerHeight = x * MINIMUM_RESULT_HEIGHT_PX + x * RESULT_GAP_PX - RESULT_GAP_PX
	// containerHeight + RESULT_GAP_PX = x * MINIMUM_RESULT_HEIGHT_PX + x * RESULT_GAP_PX
	// containerHeight + RESULT_GAP_PX = x * (MINIMUM_RESULT_HEIGHT_PX + RESULT_GAP_PX)
	// x = (containerHeight + RESULT_GAP_PX) / (MINIMUM_RESULT_HEIGHT_PX + RESULT_GAP_PX)
	return Math.ceil((containerHeight + RESULT_GAP_PX) / (MINIMUM_RESULT_HEIGHT_PX + RESULT_GAP_PX));
};
